<template>

  <div class="admin-message" @click.stop="showMsg = !showMsg">
    <a-popover arrow-point-at-center :maskClosable="false" :visible="showMsg"
               overlayClassName="ant-popover-placement-self ant-popover-message"
               placement="rightTop" trigger="click">
      <template #content>
        <div class="message" @click.stop>

          <a-tabs v-model:activeKey="tab" centered>
            <a-tab-pane key="1">
              <template #tab>
                <a-badge :count="total.data.notices">
                  公告
                </a-badge>
              </template>
            </a-tab-pane>
            <a-tab-pane key="2">
              <template #tab>
                <a-badge :count="total.data.events">
                  活动
                </a-badge>
              </template>
            </a-tab-pane>
          </a-tabs>

          <ul class="content">

            <template v-for="(i,k) of lists" :key="k">
              <li class="message-item">
                <div class="left">
                  <a-tag color="pink" v-if="i.un == 0">未读</a-tag>
                  <a-tag color="green" v-else>已读</a-tag>
                </div>
                <div class="right">
                  <div class="top" @click="show(i)"> {{ i.title }} </div>
                  <div class="bottom">
                    {{ i.date }}
                  </div>
                </div>
              </li>
            </template>

          </ul>
        </div>
      </template>
      <a-badge :count="total.data.total">
        <v-icon style="cursor: pointer;" icon="BellOutlined" size="16px"/>
      </a-badge>
    </a-popover>
  </div>

  <!-- 显示公告 -->
  <admin-message-content :title="article.data.title" :html="article.data.html" v-model:visible="visible"/>

</template>

<script setup>

import {onMounted, ref, watch} from 'vue';
import AdminMessageContent from "@/layouts/admin-header/admin-message-content.vue";
import {delay, store} from "@/common";
import {useLocalStorage} from "@vueuse/core";
import dayjs from "dayjs";
import axios from "axios";
import load from "@/common/load";
import api from "@/service/api";

const tab = ref("1"); //激活的tab
const visible = ref(false);
const showMsg = ref(false);
let canClose = true;

/* 文章 */
const article = store({
  title: "",
  content: ""
});

/* 上次公告更新时间 */
const update = useLocalStorage('update_article', "");

/* 数量 */
const total = store({
  total: 0,
  notices: 0,
  events: 0,
})

/* 文章数 */
const lists = ref([]);

/* 展示文章 */
const show = (item) => {
  article.$set(item);
  if(item.a_type == 1 && item.un == 0){
    total.data.total = total.data.total -1;
    total.data.notices = total.data.notices -1;
  }
  if(item.a_type == 2 && item.un == 0){
    total.data.total = total.data.total -1;
    total.data.events = total.data.events -1;
  }
  visible.value = true;

  axios.get(api.user_article_un + "?id=" + item.id)
      .then(() => {
      }).catch(() => {
  }).finally(() => {
    /* 关闭加载效果 */
    load.loaded();
  });
}

/* 监听消息弹出 */
watch(() => visible.value, () => {
  if (visible.value) {
    canClose = false;
  } else {
    delay(() => {
      canClose = true;
    }, 500)
  }
})

/* 点击其他地方关闭 */
document.addEventListener('click', () => {
  if (canClose) showMsg.value = false;
});

/* 加载文章 */
const loadData = () => {

  /* 显示加载效果 */
  load.loading("加载中...");
  lists.value = []; //清空

  try {
    /* 开始请求 */
    axios.get(api.user_article_list + "?type=" + tab.value)
        .then((res) => {
          /*
          * 判断请求结果
          * */
          if (res.data.code) {
            lists.value = res.data.data;
          } else {
            /* 弹出错误原因 */
            load.error(res.data.errMsg);
          }
        }).catch((e) => {
      /* 弹出错误原因 */
      load.error(e.message);
    }).finally(() => {
      /* 关闭加载效果 */
      load.loaded();
    });
  } catch (e) {
    console.log(e)
    load.error(e);
  }

}

/* 显示时加载数据，切换时加载数据 */
watch(() => [showMsg.value, tab.value], () => {
  if (showMsg.value) {
    loadData();
  }
})

/* 初始化数据 */
onMounted(() => {

  try {
    /* 开始请求 */
    axios.get(api.user_article_count)
        .then((res) => {
          /*
          * 判断请求结果
          * */
          if (res.data.code) {

            /* 更新总数 */
            total.$set(res.data.data.data);

            /* 如果有更新 */
            if (!update.value) {
              showMsg.value = true;
              //update.value = res.data.data.update;
            } else if (dayjs(update.value).isBefore(dayjs(res.data.data.update))) {
              showMsg.value = true;
              //update.value = res.data.data.update;
            }


          } else {
            /* 弹出错误原因 */
            load.error(res.data.errMsg);
          }
        }).catch((e) => {
      /* 弹出错误原因 */
      load.error(e.message);
    })
  } catch (e) {
    console.log(e)
    load.error(e);
  }

})


</script>


<style lang="scss">
.ant-popover-message {
  width: 480px;

  .ant-popover-inner-content {
    padding: 0;
  }

  .ant-tag {
    line-height: 16px;
  }

  .message {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 45vh;


    .ant-tabs-nav-list {
      width: 100%;

      .ant-tabs-tab {
        width: 100%;
        justify-content: center;
        padding: 15px 0;
      }
    }


    .content {
      list-style: none;
      overflow: auto;
      @include scroll-bar();
      height: 100%;
      padding: 5px 15px 15px;
      margin: 0;
      width: 100%;

      .message-item {
        @include flex-center;
        justify-content: flex-start;
        border-bottom: 1px solid $border;
        padding: 6px 0 12px;
        cursor: pointer;

        .left {
          width: fit-content;
          flex-shrink: 0;
        }

        .right {
          display: flex;
          justify-content: space-between;
          width: 100%;
          margin-left: 12px;

          .top {
            font-size: $font-size-4;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;


            &:hover {
              color: $primary-color;
            }
          }

          .bottom {
            font-size: $font-size-4;
            color: $text-color-4;
            flex-shrink: 0;
          }
        }

      }
    }


  }
}
</style>

<style scoped lang="scss">
.admin-message {
  @include flex-center;
  justify-content: center;
  cursor: pointer;

  width: 30px;
  height: 30px;

  margin-right: 25px;
  padding: 5px;
  border-radius: 50%;

  color: $text-color-3;

  border: 1px solid $border;


}
</style>